module.exports = __webpack_public_path__ + "assets/images/25L-route-sheet.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/25L-route-sheet.png
// module id = 1296
// module chunks = 1